import { EDITOR_MODE } from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import get from "lodash/get"
import QuestionHeader from "../Question/QuestionHeader"
import Tasklist from "./Tasklist"
import { CompletedTasks, ListContainer } from "./ui"

const TasklistEdit = (props) => {
  const { data, blockStyles, onChange } = props
  const { t } = useTranslate()

  const completeText = `${t("blocks.tasklist.completed")}: 0/${get(
    data,
    "tasks.length",
    0
  )}`

  return (
    <Content.Container>
      <ListContainer blockStyles={blockStyles}>
        <QuestionHeader
          {...props}
          data={{ ...data, question: data.title }}
          onChange={({ question, description }) => {
            if (question) return onChange({ title: question })

            onChange({ description })
          }}
        />
        <CompletedTasks mode={EDITOR_MODE.EDIT}>{completeText}</CompletedTasks>
        <Tasklist {...props} mode={EDITOR_MODE.EDIT} />
      </ListContainer>
    </Content.Container>
  )
}

export default TasklistEdit
